// extracted by mini-css-extract-plugin
export var gif = "_hx-0";